import Interpolate from '@doist/react-interpolate'

export default function CustomInterpolate({ t, i18nKey, ...props }) {
    return <Interpolate string={t(i18nKey, { skipInterpolation: true })} {...props} />
}
